module.exports = __webpack_public_path__ + "static/media/blastoff-es.716410a9.png";